import React, { useState, useRef, useEffect } from "react";
import {
  DialogRoot,
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "components/ui/dialog";
import { Input, Button } from "@chakra-ui/react";
import { toast } from "react-toastify";
import api from "utils/apiService";
import Switch from "components/switch";
import PermissionsSelector from "./PermissionsSelector";
import { getDashboardRoutes } from "../utils";

const EditAdmin = ({ admin, refetch }) => {
  const [formData, setFormData] = useState({
    name: admin.name,
    phoneNumber: admin.phoneNumber,
    enabledDashboardPaths: admin.enabledDashboardPaths || [],
    superAdmin: admin.superAdmin || false,
  });

  const [dashboardRoutes, setDashboardRoutes] = useState([]);
  const closeRef = useRef();

  useEffect(() => {
    import("routes.js").then((mod) => {
      setDashboardRoutes(getDashboardRoutes(mod.default));
    });
  }, []);

  const handleUpdate = async () => {
    if (!formData.name || !formData.phoneNumber) {
      return toast.error("الرجاء ملء جميع الحقول");
    }

    const body = {
      ...formData,
      enabledDashboardPaths: formData.superAdmin
        ? []
        : formData.enabledDashboardPaths,
    };
    const res = await api.patch(`/users/${admin.id}`, body);
    if (res.error) {
      toast.error(res.error);
    } else {
      toast.success("تم تحديث البيانات بنجاح");
      closeRef.current.click();
      if (refetch) refetch();
    }
  };

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button className="rounded-full bg-blue-500 px-6 py-1 text-white transition-all hover:bg-blue-600">
          تعديل
        </button>
      </DialogTrigger>

      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">تعديل المسؤول</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <div className="mb-4">
            <label className="mb-2 block text-base" htmlFor="name">
              الاسم
            </label>
            <Input
              id="name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="w-full border p-2"
            />
          </div>

          <div className="mb-4">
            <label className="mb-2 block text-base" htmlFor="phone">
              رقم الهاتف
            </label>
            <Input
              id="phone"
              value={formData.phoneNumber}
              onChange={(e) =>
                setFormData({ ...formData, phoneNumber: e.target.value })
              }
              className="w-full border p-2"
            />
          </div>

          <div className="mb-4 flex items-center gap-2">
            <Switch
              id="superAdmin"
              checked={formData.superAdmin}
              onChange={(e) =>
                setFormData({ ...formData, superAdmin: e.target.checked })
              }
            />
            <label htmlFor="superAdmin" className="text-base">
              مدير عام
            </label>
          </div>

          {!formData.superAdmin && (
            <div className="mb-4">
              <label className="mb-2 block text-base" htmlFor="routes">
                الصلاحيات المسموح بها
              </label>
              <PermissionsSelector
                routes={dashboardRoutes}
                selected={formData.enabledDashboardPaths}
                onChange={(paths) =>
                  setFormData((prev) => ({
                    ...prev,
                    enabledDashboardPaths: paths,
                  }))
                }
              />
            </div>
          )}
        </DialogBody>

        <DialogFooter>
          <Button onClick={handleUpdate} variant="outline">
            تحديث
          </Button>
          <DialogActionTrigger asChild ref={closeRef}>
            <Button variant="outline">إلغاء</Button>
          </DialogActionTrigger>
        </DialogFooter>

        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default EditAdmin;
